import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
export default function Empresas() {
  const { t } = useTranslation('empresas');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-[#F6F2EC]">

      {/* Hero Section */}
      <section className="relative min-h-[75vh] flex items-end overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 w-full h-full">
          <img
            src="https://public.readdy.ai/ai/img_res/2c028d19ac0de8386fb6c2ddd7228ac6.jpg"
            alt="Empresas FGT"
            className="w-full h-full object-cover object-top"
          />
        </div>
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0B0B]/92 via-[#0B0B0B]/50 to-[#0B0B0B]/15"></div>
        {/* Accent line */}
        <div className="absolute bottom-0 left-0 right-0 h-[3px] bg-[#F97700]"></div>

        {/* Content */}
        <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-12 pb-24 pt-48">
          <div className="max-w-3xl">
            <p className="text-xs font-semibold tracking-[0.25em] uppercase text-[#F97700] mb-6">
              {t('hero.label', 'Empresas')}
            </p>
            <h1 className="text-5xl lg:text-7xl font-semibold text-white leading-[1.05] mb-8 drop-shadow-lg">
              {t('hero.title')}
            </h1>
            <p className="text-xl text-white/80 leading-relaxed mb-12 max-w-2xl">
              {t('hero.subtitle')}
            </p>
            <div className="flex flex-wrap gap-4">
              <a
                href="/diagnostico"
                className="inline-flex items-center justify-center px-8 py-4 bg-[#F97700] hover:bg-[#E56E00] text-white font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                {t('hero.cta_primary')}
              </a>
              <a
                href="https://wa.me/5511930322408"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-8 py-4 bg-white/10 hover:bg-white/20 border border-white/30 text-white font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line mr-2"></i>
                {t('hero.cta_secondary')}
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Aplicações Corporativas */}
      <section className="py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="max-w-2xl mb-20">
            <p className="text-xs font-semibold text-[#F97700] uppercase tracking-wider mb-4">
              {t('applications.label')}
            </p>
            <h2 className="text-4xl font-semibold text-[#0B0B0B] leading-tight">
              {t('applications.title')}
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {(t('applications.items', { returnObjects: true }) as Array<{ title: string; description: string; icon: string }>).map((item, index) => (
              <div
                key={index}
                className="bg-[#FBF8F3] border border-[#E7E1D9] p-10 hover:border-[#F97700] transition-colors"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-[#FFF1E6] text-[#F97700] mb-6">
                  <i className={`ri-${item.icon}-line text-2xl`}></i>
                </div>
                <h3 className="text-xl font-semibold text-[#0B0B0B] mb-4">
                  {item.title}
                </h3>
                <p className="text-[#2E2E2E] leading-relaxed">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Quando Faz Sentido */}
      <section className="py-32 bg-[#FBF8F3] border-y border-[#E7E1D9]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="max-w-2xl mb-20">
            <p className="text-xs font-semibold text-[#F97700] uppercase tracking-wider mb-4">
              {t('when.label')}
            </p>
            <h2 className="text-4xl font-semibold text-[#0B0B0B] leading-tight">
              {t('when.title')}
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {(t('when.scenarios', { returnObjects: true }) as Array<{ title: string; description: string; points: string[] }>).map((scenario, index) => (
              <div
                key={index}
                className="bg-white border border-[#E7E1D9] p-10 hover:border-[#F97700] transition-colors"
              >
                <h3 className="text-xl font-semibold text-[#0B0B0B] mb-4">
                  {scenario.title}
                </h3>
                <p className="text-[#2E2E2E] leading-relaxed mb-6">
                  {scenario.description}
                </p>
                <ul className="space-y-3">
                  {scenario.points.map((point, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <span className="w-1.5 h-1.5 bg-[#F97700] rounded-full mt-2 shrink-0"></span>
                      <span className="text-sm text-[#2E2E2E] leading-relaxed">{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Método de Estruturação */}
      <section className="py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="max-w-2xl mb-20">
            <p className="text-xs font-semibold text-[#F97700] uppercase tracking-wider mb-4">
              {t('method.label')}
            </p>
            <h2 className="text-4xl font-semibold text-[#0B0B0B] leading-tight mb-6">
              {t('method.title')}
            </h2>
            <p className="text-lg text-[#2E2E2E] leading-relaxed">
              {t('method.description')}
            </p>
          </div>

          <div className="space-y-6">
            {(t('method.steps', { returnObjects: true }) as Array<{ title: string; description: string }>).map((step, index) => (
              <div
                key={index}
                className="flex items-start gap-6 bg-[#FBF8F3] border border-[#E7E1D9] p-8 hover:border-[#F97700] transition-colors"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-[#0B0B0B] text-white font-semibold shrink-0">
                  {String(index + 1).padStart(2, '0')}
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-semibold text-[#0B0B0B] mb-3">
                    {step.title}
                  </h3>
                  <p className="text-[#2E2E2E] leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Governança e Clareza */}
      <section className="py-32 bg-[#FBF8F3] border-t border-[#E7E1D9]">
        <div className="max-w-4xl mx-auto px-6 lg:px-12">
          <div className="bg-white border-l-4 border-[#F97700] p-10">
            <p className="text-xs font-semibold text-[#F97700] uppercase tracking-wider mb-4">
              {t('governance.label')}
            </p>
            <h3 className="text-2xl font-semibold text-[#0B0B0B] mb-6">
              {t('governance.title')}
            </h3>
            <div className="space-y-4 text-[#2E2E2E] leading-relaxed">
              {(t('governance.points', { returnObjects: true }) as string[]).map((point, index) => (
                <p key={index}>{point}</p>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="py-32 bg-[#0B0B0B]">
        <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
          <h2 className="text-4xl font-semibold text-white mb-6">
            {t('cta.title')}
          </h2>
          <p className="text-lg text-white/80 mb-12 max-w-2xl mx-auto">
            {t('cta.subtitle')}
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a
              href="/diagnostico"
              className="inline-flex items-center justify-center px-8 py-4 bg-[#F97700] hover:bg-[#E56E00] text-white font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              {t('cta.button_primary')}
            </a>
            <a
              href="https://wa.me/5511930322408"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-8 py-4 bg-white hover:bg-white/90 text-[#0B0B0B] font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              {t('cta.button_secondary')}
            </a>
          </div>
        </div>
      </section>

    </div>
  );
}
